import axios from 'axios';
import config from '../../config'; // Ajusta la ruta según tu estructura

const baseUrl = config.baseUrl;
//const baseUrl = 'http://localhost:5000';

// Función para reemplazar valores nulos por '-'
const replaceNullWithDash = (value) => (value === null || value === undefined) ? '-' : value;


// Función para obtener datos del mapa de Colombia
const getMapColombia = async () => {
    try {
        const response = await axios.get(`${baseUrl}/api/mapColombia`);
        const data = response.data.data; // Ajusta según el formato de respuesta

        const processedData = data.map(depto => {
            const hombres = depto.totalHombres != null ? Number(depto.totalHombres) : null;
            const mujeres = depto.totalMujeres != null ? Number(depto.totalMujeres) : null;

            const total = hombres != null && mujeres != null ? hombres + mujeres : null;

            const pctHombres =
                total && hombres != null ? Math.round((hombres / total) * 100) : null;

            const pctMujeres =
                total && mujeres != null ? Math.round((mujeres / total) * 100) : null;

            return {
                id: depto.codLib,
                idCodInterno: depto.oid,
                nameFusion: depto.nameFusion,
                value: replaceNullWithDash(depto.numOrganizaciones),
                color: '#4275af',
                hoverBorderThickness: '2',

                toolText: `
          <div style="font-family: Arial, sans-serif; font-size: 14px;">
            <table style="width:100%; border-collapse:collapse;">
              <tbody>
          
                <tr>
                  <td colspan="2"
                      style="font-weight:bold;font-size:16px;color:#333;
                             padding-bottom:8px;border-bottom:2px solid #d0d0d0;">
                    ${depto.departamento}
                  </td>
                </tr>
          
                <tr>
                  <td style="vertical-align:top;padding-right:10px;border-right:2px solid #d0d0d0;">
                    <ul style="margin:0;padding-left:15px;">
                      ${depto.listaMunicipios
                        ? depto.listaMunicipios
                            .split('</li><li>')
                            .map(m => `<li>${m.replace(/<\/?li>/g, '')}</li>`)
                            .join('')
                        : '<li>-</li>'
                    }
                    </ul>
                  </td>
          
                  <td style="vertical-align:top;padding-left:10px;">
                    <ul style="margin:0;padding-left:15px;">
                      <li>
                        <strong>Hombres:</strong>
                        ${hombres != null ? hombres.toLocaleString('es-CO') : '-'}
                        ${pctHombres != null ? ` - ${pctHombres}%` : ''}
                      </li>
          
                      <li>
                        <strong>Mujeres:</strong>
                        ${mujeres != null ? mujeres.toLocaleString('es-CO') : '-'}
                        ${pctMujeres != null ? ` - ${pctMujeres}%` : ''}
                      </li>
          
                      <li>
                        <strong>Total Familias:</strong>
                        ${total != null ? total.toLocaleString('es-CO') : '-'}
                      </li>
                    </ul>
                  </td>
                </tr>
          
              </tbody>
            </table>
          </div>
              `,
            };
        });

        return {
            status: response.status,
            data: {
                data: processedData // Asegúrate de que este campo se corresponda con lo esperado por FusionCharts
            }
        };
    } catch (error) {
        console.error('Error al obtener datos del mapa de Colombia:', error);
        throw error; // Lanza el error para ser manejado en el componente React
    }
};

export { getMapColombia };
